import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "./App.css";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import Loading from "./components/Loading";
import LanguageSwitcher from "./components/LanguageSwitcher";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import EnglishAbout from "./pages/EnglishAbout";
import ArabicAbout from "./pages/ArabicAbout";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Announcements from "./pages/Announcements";
import Applications from "./pages/Applications";
import Support from "./pages/Support";
import Academy from "./pages/Academy";
import CookiePolicy from "./pages/CookiePolicy";

// English Pages
import HomeEN from "./pages/en/HomeEN";
import AboutEN from "./pages/en/AboutEN";
import ProjectsEN from "./pages/en/ProjectsEN";
import ContactEN from "./pages/en/ContactEN";
import AnnouncementsEN from "./pages/en/AnnouncementsEN";
import ApplicationsEN from "./pages/en/ApplicationsEN";
import AcademyEN from "./pages/en/AcademyEN";
import SupportEN from "./pages/en/SupportEN";
import CookiePolicyEN from "./pages/en/CookiePolicyEN";
import AnnouncementDetailEN from "./pages/en/AnnouncementDetailEN";
import ApplicationDetailEN from "./pages/en/ApplicationDetailEN";
import EducationTechEN from "./pages/en/EducationTechEN";
import DataScienceEN from "./pages/en/DataScienceEN";
import MobileWebEN from "./pages/en/MobileWebEN";
import CorporateWebEN from "./pages/en/CorporateWebEN";
import CorporateSoftwareEN from "./pages/en/CorporateSoftwareEN";
import SocialResponsibilityEN from "./pages/en/SocialResponsibilityEN";
import CorporateSoftware from "./pages/ProjectPages/CorporateSoftware";
import EducationTech from "./pages/ProjectPages/EducationTech";
import DataScience from "./pages/ProjectPages/DataScience";
import MobileWeb from "./pages/ProjectPages/MobileWeb";
import CorporateWeb from "./pages/ProjectPages/CorporateWeb";
import SocialResponsibility from "./pages/ProjectPages/SocialResponsibility";
import AnnouncementDetail from "./pages/AnnouncementPages/AnnouncementDetail";
import ApplicationDetail from "./pages/ApplicationPages/ApplicationDetail";
// import Login from "./pages/Login"; // leride kullanılacak

function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // Route değiştiğinde loading'i göster
  useEffect(() => {
    setLoading(true);
    // Bir sonraki frame'de loading'i kapat (yapay delay yok, sadece render cycle)
    const frameId = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setLoading(false);
      });
    });

    return () => cancelAnimationFrame(frameId);
  }, [location.pathname]);

  return (
    <>
      {loading && <Loading />}
      <ScrollToTop />
      <Helmet>
        <meta charSet="utf-8" />
        <title>ProgenX - Eğitim ve Bilişim Teknolojileri</title>
        <meta name="description" content="ProgenX Eğitim ve Bilişim Teknolojileri - Yapay Zeka, Yazılım ve Eğitim çözümleri sunan yenilikçi teknoloji şirketi" />
        <meta name="keywords" content="progenx, yapay zeka, yazılım, eğitim, teknoloji, akademi, bilişim" />
        <link rel="canonical" href="https://progenxacademy.com" />
      </Helmet>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkinda" element={<About />} />
        <Route path="/en" element={<HomeEN />} />
        <Route path="/en/about" element={<AboutEN />} />
        <Route path="/en/projects" element={<ProjectsEN />} />
        <Route path="/en/contact" element={<ContactEN />} />
        <Route path="/en/announcements" element={<AnnouncementsEN />} />
        <Route path="/en/applications" element={<ApplicationsEN />} />
        <Route path="/en/academy" element={<AcademyEN />} />
        <Route path="/en/support" element={<SupportEN />} />
        <Route path="/en/cookie-policy" element={<CookiePolicyEN />} />
        <Route path="/en/announcements/:slug" element={<AnnouncementDetailEN />} />
        <Route path="/en/applications/:slug" element={<ApplicationDetailEN />} />
        <Route path="/en/projects/education-technologies" element={<EducationTechEN />} />
        <Route path="/en/projects/data-science-ai" element={<DataScienceEN />} />
        <Route path="/en/projects/mobile-web-applications" element={<MobileWebEN />} />
        <Route path="/en/projects/corporate-web-solutions" element={<CorporateWebEN />} />
        <Route path="/en/projects/corporate-software" element={<CorporateSoftwareEN />} />
        <Route path="/en/projects/social-responsibility" element={<SocialResponsibilityEN />} />
        <Route path="/ar" element={<ArabicAbout />} />
        <Route path="/projeler" element={<Projects />} />
        <Route path="/projeler/kurumsal-yazilim" element={<CorporateSoftware />} />
        <Route path="/projeler/egitim-teknolojileri" element={<EducationTech />} />
        <Route path="/projeler/veri-bilimi-yapay-zeka" element={<DataScience />} />
        <Route path="/projeler/mobil-web-uygulamalari" element={<MobileWeb />} />
        <Route path="/projeler/kurumsal-web-cozumleri" element={<CorporateWeb />} />
        <Route path="/projeler/sosyal-sorumluluk" element={<SocialResponsibility />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/duyurular" element={<Announcements />} />
        <Route path="/duyurular/:slug" element={<AnnouncementDetail />} />
        <Route path="/uygulamalar" element={<Applications />} />
        <Route path="/uygulamalar/:slug" element={<ApplicationDetail />} />
        <Route path="/sizden-gelenler" element={<Applications />} />
        <Route path="/destek" element={<Support />} />
        <Route path="/progenxakademi" element={<Academy />} />
        <Route path="/cerez-politikasi" element={<CookiePolicy />} />
        {/* <Route path="/giris" element={<Login />} /> */}
      </Routes>
      <div className="page-language-switcher">
        <LanguageSwitcher />
      </div>
      <Footer />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AppContent />
      </div>
    </HelmetProvider>
  );
}

export default App;
